import { useTranslation } from 'react-i18next';
import { computeScore, grade } from '../lib/preservation';

function PreservationScore({ verdict }) {
  const { t } = useTranslation();

  if (!verdict || !verdict.totalGames) return null;

  const score = computeScore(verdict);
  const g = grade(score);

  return (
    <div className={`pscore pscore--${g.tone}`}>
      <span className="pscore__grade">{g.letter}</span>
      <div className="pscore__body">
        <span className="pscore__num">
          {score}<em>/100</em>
        </span>
        <span className="pscore__label">{t(`pscore.label_${g.tone}`)}</span>
      </div>
    </div>
  );
}

export default PreservationScore;
